import { FormControl, FormGroup, Grid, Switch, TextField } from '@mui/material';
import Button from '@mui/material/Button';
import { Box } from '@mui/system';
import { Link } from 'react-router-dom';

import configUrls from '../../config/configUrls';
import { Secretaria } from '../../types/secretaria/Secretaria';
import CepInput from '../../components/formControls/CepInput';
import TxtOrgao from '../autoComplete/TxtOrgao';
import { Orgao } from '../../types/orgao/Orgao';
import { useSecretariaRoutes } from '../../config/useSecretariaRoutes';



type Props = {
    data: Secretaria,
    isdisabled?: boolean,
    isLoading?: boolean,
    handleSubmit?: (e: React.FormEvent<HTMLFormElement>) => void;
    handleChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
    handleCepChange: (newCep: string) => void;
    handleSearchOrgaoChange: (parOrgao: Orgao) => void;
}

export function SecretariaForm({
    data,
    isdisabled = false,
    isLoading = false,
    handleSubmit,
    handleChange,
    handleCepChange,
    handleSearchOrgaoChange,
}: Props) {

    const secretariaRoutes=useSecretariaRoutes();



    return (
        <Box mt={2} p={2}>

            <form onSubmit={handleSubmit} method='POST'>

                <Grid container spacing={3}>


                    <Grid item xs={12}>
                        <FormControl fullWidth>
                            <TxtOrgao
                                required
                                value={data.orgao}
                                handleSearchChange={handleSearchOrgaoChange}
                            />
                        </FormControl>
                    </Grid>
                    <Grid item xs={12}>

                        <FormControl fullWidth>
                            <TextField
                                required
                                label="Nome"
                                name="nome"
                                disabled={isdisabled}
                                onChange={handleChange}
                                size="small"
                                inputProps={{ maxLength: 255 }}
                                value={data.nome} />
                        </FormControl>
                    </Grid>
                    <Grid item xs={12}>
                        <FormControl fullWidth>
                            <TextField
                                required
                                label="Abreviatura"
                                name="abreviatura"
                                disabled={isdisabled}
                                onChange={handleChange}
                                size="small"
                                inputProps={{ maxLength: 10 }}
                                value={data.abreviatura} />
                        </FormControl>
                    </Grid>

                    <Grid item xs={12}>
                        <FormControl fullWidth>
                            <TextField

                                label="Descrição"
                                name="descricao"
                                disabled={isdisabled}
                                onChange={handleChange}
                                size="small"
                                inputProps={{ maxLength: 255 }}
                                value={data.descricao} />

                        </FormControl>
                    </Grid>
                    <Grid item xs={12}>
                        <FormControl fullWidth>
                            <TextField

                                label="Endereço"
                                name="endereco"
                                disabled={isdisabled}
                                onChange={handleChange}
                                size="small"
                                inputProps={{ maxLength: 255 }}
                                value={data.endereco} />
                        </FormControl>
                    </Grid>

                    <Grid item xs={12}>
                        <Box display="flex" justifyContent="space-between">

                            <FormControl sx={{ width: "50%", marginRight: "10px" }}>
                                <TextField

                                    label="Número"
                                    name="numero"
                                    disabled={isdisabled}
                                    onChange={handleChange}
                                    size="small"
                                    inputProps={{ maxLength: 10 }}
                                    value={data.numero} />
                            </FormControl>

                            <FormControl sx={{ width: "70%", marginRight: "10px" }}>
                                <TextField
                                    label="Complemento"
                                    name="complemento"
                                    disabled={isdisabled}
                                    onChange={handleChange}
                                    size="small"
                                    inputProps={{ maxLength: 50 }}
                                    value={data.complemento} />
                            </FormControl>

                            <FormControl fullWidth>
                                <TextField
                                    label="Bairro"
                                    name="bairro"
                                    disabled={isdisabled}
                                    onChange={handleChange}
                                    size="small"
                                    inputProps={{ maxLength: 50 }}
                                    value={data.bairro} />
                            </FormControl>

                        </Box>
                    </Grid>

                    <Grid item xs={12}>
                        <Box display="flex" justifyContent="space-between" >

                            <FormControl sx={{ width: "29%", marginRight: "10px" }}>
                                <CepInput
                                    required={false}
                                    label="CEP"
                                    name="cep"
                                    disabled={isdisabled}
                                    handleCepChange={handleCepChange}
                                    value={data.cep || ''}
                                />
                            </FormControl>

                            <FormControl fullWidth>
                                <TextField

                                    label="Cidade"
                                    name="cidade"
                                    disabled={isdisabled}
                                    onChange={handleChange}
                                    size="small"
                                    inputProps={{ maxLength: 100 }}
                                    value={data.cidade} />
                            </FormControl>



                        </Box>
                    </Grid>

                    <Grid item xs={12}>
                        <FormControl fullWidth>
                            <TextField

                                label="Telefone"
                                name="telefone"
                                disabled={isdisabled}
                                onChange={handleChange}
                                size="small"
                                inputProps={{ maxLength: 50 }}
                                value={data.telefone} />
                        </FormControl>
                    </Grid>



                    <Grid item xs={12}>
                        <Box display="flex" gap={2}>

                            <Button
                                type="submit"
                                variant="contained"
                                color="secondary"
                                disabled={isdisabled}
                            >
                                Gravar
                            </Button>

                            <Button
                                variant="contained"
                                component={Link}
                                to={secretariaRoutes.SECRETARIA_LIST}
                            >
                                Voltar
                            </Button>
                        </Box>
                    </Grid>
                </Grid>

            </form>



        </Box >
    )
}